import OrdersPartial, {name} from "./OrdersPartial";

export {name};
export default OrdersPartial;
